import Keycloak from 'keycloak-js';
import { configuration } from 'src/config';
const keycloakConfig = new Keycloak({
  url: configuration.winkLoginAuthURL,
  realm: configuration.winkLoginRealm,
  clientId: configuration.winkLoginClientId,
});
export default keycloakConfig;
